const CHAT_BELL_SOUND_PATH = '/sounds/chat-bell.mp3';

let notificationAudio = null;
let audioUnlocked = false;

const getNotificationAudio = () => {
  if (typeof window === 'undefined' || typeof window.Audio !== 'function') {
    return null;
  }

  if (!notificationAudio) {
    notificationAudio = new window.Audio(CHAT_BELL_SOUND_PATH);
    notificationAudio.preload = 'auto';
    notificationAudio.load();
  }

  return notificationAudio;
};

const buildPlaybackFailure = (error) => {
  const errorName = String(error?.name || 'Error');

  if (errorName === 'NotAllowedError') {
    return {
      ok: false,
      status: 'blocked',
      reason: 'autoplay_blocked',
      errorName,
      message: 'Browser blocked audio. Click Test Bell Sound again after interacting with the page.',
    };
  }

  return {
    ok: false,
    status: 'failed',
    reason: errorName === 'AbortError' ? 'playback_aborted' : 'playback_failed',
    errorName,
    message: errorName === 'AbortError' ? 'Sound playback was interrupted' : 'Sound file unavailable',
  };
};

export const playChatNotificationBell = async () => {
  const audio = getNotificationAudio();
  if (!audio) {
    return {
      ok: false,
      status: 'failed',
      reason: 'audio_unavailable',
      message: 'Sound playback is not available in this browser.',
    };
  }

  try {
    audio.pause();
    audio.currentTime = 0;
    audio.muted = false;

    const playResult = audio.play();
    if (playResult && typeof playResult.then === 'function') {
      await playResult;
    }

    audioUnlocked = true;
    return {
      ok: true,
      status: 'played',
      reason: '',
      message: 'Sound played',
    };
  } catch (error) {
    return buildPlaybackFailure(error);
  }
};

export const unlockChatNotificationAudio = async () => {
  const audio = getNotificationAudio();
  if (!audio) {
    return { ok: false, status: 'failed', reason: 'audio_unavailable' };
  }

  if (audioUnlocked) {
    return { ok: true, status: 'ready', reason: '' };
  }

  const wasMuted = audio.muted;
  try {
    audio.muted = true;
    audio.currentTime = 0;
    const playResult = audio.play();
    if (playResult && typeof playResult.then === 'function') {
      await playResult;
    }
    audio.pause();
    audio.currentTime = 0;
    audioUnlocked = true;
    return { ok: true, status: 'ready', reason: '' };
  } catch (error) {
    return buildPlaybackFailure(error);
  } finally {
    audio.muted = wasMuted;
  }
};

export const playChatNotificationBellPreview = playChatNotificationBell;
